module.exports = __webpack_public_path__ + "img/galeria-12.c782082d.jpg";